import(/* webpackMode: "eager" */ "/opt/atlassian/pipelines/agent/build/src/app/auth/forgot-password/page.tsx");
